import BypassAddressValidationState from "@aus/Store/Pages/CheckoutShipping/BypassAddressValidationState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

const initialState: BypassAddressValidationState = {
    byPassAddressValidation: false,
};

const reducer = {
    "Pages/CheckoutShipping/UpdateByPassAddressValidation": (
        draft: Draft<BypassAddressValidationState>,
        action: { parameter: BypassAddressValidationState },
    ) => {
        draft.byPassAddressValidation = action.parameter.byPassAddressValidation;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
